module.exports = __webpack_public_path__ + "static/assets/42800ff342bbfba1f0a65f72eb3e8bf3.svg";